module.exports = __webpack_public_path__ + "static/media/x-card-red.30cddf12.svg";